// src/services/Notification/notification.service.ts

import axios from "axios";
import { environment } from "../../environments/environment";

const API_BASE_NAME = `${environment.apiBaseUrl}`;

// ================================
// TYPES
// ================================

export interface NotificationType {
  id?: number;
  title: string;
  description: string;
  userIds?: number[];
  userType?: string;
  createdAt?: string;
  BuyerSellerModel?: {
    fullName?: string;
    businessName?: string;
  };
}

// ================================
// GET ALL ADMIN NOTIFICATIONS
// ================================

export const getAllAdminNotificationsApi = async (): Promise<{
  success: boolean;
  data: NotificationType[];
}> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${API_BASE_NAME}/admin/notifications`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

// ================================
// SEND CUSTOM NOTIFICATION
// ================================

export const sendCustomNotificationApi = async (
  data: NotificationType
) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API_BASE_NAME}/admin/send-notification`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error sending notification:", error);
    throw error;
  }
};